import Vue from "vue";
import Router from "vue-router";

// Containers
const TheContainer = () => import("@/containers/TheContainer");

// Views
// const Welcome = () => import('@/views/pages/Welcome')
const ChatFlow = () => import("@/views/pages/flow-builder/index");
const ChatAnalysis = () => import("@/views/pages/chat-analysis/index");
const MessageLog = () => import("@/views/pages/message-log/index");
const MessageLogDetail = () => import("@/views/pages/message-log/Details");
const SettingTime = () => import("@/views/pages/setting-time/index");
const SettingWidget = () => import("@/views/pages/setting-widget/Index");
const User = () => import("@/views/pages/user/Index");
const UserDetail = () => import("@/views/pages/user/Details");
const SentimentTraining = () =>
  import("@/views/pages/sentiment-training/index");
const ImageMap = () => import("@/views/pages/image-map/index");
const EmailConfig = () => import("@/views/pages/email-config/Index");
const Page404 = () => import("@/views/pages/Page404");
const Page500 = () => import("@/views/pages/Page500");
const Login = () => import("@/views/pages/Login");

Vue.use(Router);

export default new Router({
  mode: "history",
  linkActiveClass: "active",
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: { requiresIsLogin: true },
    },
    {
      path: "/",
      redirect: "/chat-analysis",
      name: "HOME",
      component: TheContainer,
      meta: { requiresAuth: true },
      children: [
        {
          path: "/flow-builder",
          name: "FLOW BUILDER",
          component: ChatFlow,
          meta: { requiresAuth: true },
        },
        {
          path: "/message-log",
          name: "MESSAGE LOG",
          component: MessageLog,
          meta: { requiresAuth: true },
        },
        {
          path: "/message-log/details/:id/:collection",
          name: "MESSAGE LOG DETAIL",
          component: MessageLogDetail,
          meta: { requiresAuth: true },
        },
        {
          path: "/sentiment-training",
          name: "SENTIMENT TRAINING",
          component: SentimentTraining,
          meta: { requiresAuth: true },
        },
        {
          path: "/image-map",
          name: "IMAGE MAP",
          component: ImageMap,
          meta: { requiresAuth: true },
        },
        {
          path: "/setting-time",
          name: "SETTING TIME",
          component: SettingTime,
          meta: { requiresAuth: true },
        },
        {
          path: "/setting-widget",
          name: "SETTING WIDGET",
          component: SettingWidget,
          meta: { requiresAuth: true },
        },
        {
          path: "/chat-analysis",
          name: "CHAT ANALYSIS",
          component: ChatAnalysis,
          meta: { requiresAuth: true },
        },
        // {
        //   path: "/email-config",
        //   name: "Email Config",
        //   component: EmailConfig,
        //   meta: { requiresAuth: true },
        // },
        {
          path: "/user",
          name: "USER LIST",
          component: User,
          meta: { requiresAuth: true },
        },
        {
          path: "/chat",
          name: "CHAT",
          meta: { requiresAuth: true },
        },
        {
          path: "/user/details/:id",
          name: "ข้อมูล USER ID",
          component: UserDetail,
          meta: { requiresAuth: true },
        },
        {
          path: "404",
          name: "Page404",
          component: Page404,
        },
        {
          path: "500",
          name: "Page500",
          component: Page500,
        },
      ],
    },
  ],
});
